import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '@clerk/react-router';

export default function AuthCallback(): JSX.Element {
  const navigate = useNavigate();
  const { isSignedIn, isLoaded } = useAuth();

  const [error, setError] = useState<string | null>(null);

  const getErrorMessageFromUrl = (): string | null => {
    const params = new URLSearchParams(window.location.search);
    const rawError = params.get('error_description') ?? params.get('error') ?? params.get('message');

    if (!rawError) return null;

    // Normalize common OAuth formatting for better readability.
    return rawError.replace(/\+/g, ' ').replace(/_/g, ' ').trim();
  };

  useEffect(() => {
    if (!isLoaded) return;

    if (isSignedIn) {
      // Redirect to the main dashboard after successful login
      navigate('/');
    } else {
      const callbackError = getErrorMessageFromUrl();
      setError(callbackError ?? 'Authentication failed. Please try signing in again.');
    }
  }, [isLoaded, isSignedIn, navigate]);

  return (
    <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight: '100vh',
      backgroundColor: '#1B1D1F',
      color: 'white',
      fontSize: '18px',
      padding: '24px',
    }}>
      {!error && <div>Processing authentication...</div>}
      {error && (
        <div style={{ maxWidth: '600px', textAlign: 'center' }}>
          <h2 style={{ marginBottom: '12px', color: '#F4B5B5' }}>Authentication Error</h2>
          <p style={{ marginBottom: '20px', lineHeight: 1.5 }}>{error}</p>
          <button
            type='button'
            style={{
              backgroundColor: '#D2A969',
              color: '#1B1D1F',
              border: 'none',
              borderRadius: '6px',
              padding: '10px 18px',
              fontWeight: 700,
              cursor: 'pointer',
            }}
            onClick={() => navigate('/login')}
          >
            Back to Login
          </button>
        </div>
      )}
    </div>
  );
}
